var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-row-container"},_vm._l((_vm.rows),function(c,i){return _c('div',{key:i},[_c('MapCircle',{attrs:{"isPresent":c[0],"isBlinking":c[1],"duration":c[2],"opacity":c[3]}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }